// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2fvIN","icon":"SortAdornment_icon__1tZYo","up":"SortAdornment_up__2HC9S","down":"SortAdornment_down__3SYI4","active":"SortAdornment_active__GsVWc"};